// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__lsiha","footer":"ModalInfo_footer__1f7BG"};